import type { IBubbleChartDataPoint } from './types';

interface IBubbleChartOptionsParams {
  data: IBubbleChartDataPoint[];
  xAxisTitle?: string;
  yAxisTitle?: string;
  seriesName?: string;
}

export const getBubbleChartOptions = (params: IBubbleChartOptionsParams) => {
  const { data, xAxisTitle = 'X', yAxisTitle = 'Y', seriesName = 'Data' } = params;

  return {
    chart: {
      type: 'bubble',
      plotBorderWidth: 1,
      zoomType: 'xy',
    },
    title: {
      text: null,
    },
    credits: {
      enabled: false,
    },
    xAxis: {
      title: {
        text: xAxisTitle,
      },
      gridLineWidth: 1,
    },
    yAxis: {
      title: {
        text: yAxisTitle,
      },
      startOnTick: false,
      endOnTick: false,
    },
    tooltip: {
      useHTML: true,
      headerFormat: '<table>',
      pointFormat:
        '<tr><th colspan="2"><span>{point.name}</span></th></tr>' +
        '<tr><th>' +
        xAxisTitle +
        ':</th><td>{point.x:.2f}</td></tr>' +
        '<tr><th>' +
        yAxisTitle +
        ':</th><td>{point.y:.2f}</td></tr>',
      footerFormat: '</table>',
    },
    plotOptions: {
      bubble: {
        minSize: 20,
        maxSize: 60,
        dataLabels: {
          enabled: true,
          format: '{point.name}',
          style: {
            fontSize: '11px',
            fontWeight: 'normal',
          },
        },
      },
      series: {
        marker: {
          fillOpacity: 0.7,
        },
      },
    },
    series: [
      {
        name: seriesName,
        data: data,
        colorByPoint: true,
      },
    ],
  };
};
